var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.479,
    height: 101.479,
    viewBox: "0 0 101.479 101.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "investors",
    transform: "translate(-0.625 -0.625)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M10.684,32.49H2.5v-4.91A17.972,17.972,0,0,1,15.594,10.263v.949a4.91,4.91,0,0,0,9.821,0v-.949a17.94,17.94,0,0,1,7.856,4.616,19.565,19.565,0,0,0-6.22,14.338V32.49Z",
    transform: "translate(3.035 15.601)",
    fill: "#e6e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M35.243,23.023,38.517,26.3l3.274-3.274L40.5,10.044a17.981,17.981,0,0,1,16.024,17.89v4.91H31.97V29.57a19.565,19.565,0,0,0-6.22-14.338,17.927,17.927,0,0,1,10.786-5.189Z",
    transform: "translate(40.672 15.247)",
    fill: "#e6e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M34.629,10.114l1.293,12.98-3.274,3.274-3.274-3.274,1.293-12.98a17.191,17.191,0,0,1,3.961,0Z",
    transform: "translate(46.541 15.176)",
    fill: "#ff826e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M20.059,32.166H11.875V28.892a19.565,19.565,0,0,1,6.22-14.338,19.106,19.106,0,0,1,6.629-4.092l4.452,14.224,2.341,7.48Z",
    transform: "translate(18.212 15.925)",
    fill: "#4fc1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M32.082,32.166H20.625l2.341-7.48,4.452-14.224a19.1,19.1,0,0,1,6.629,4.092,19.565,19.565,0,0,1,6.22,14.338v3.274Z",
    transform: "translate(32.376 15.925)",
    fill: "#4fc1e9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M23.165,10.006,21.233,25.424,16.781,11.2A19.21,19.21,0,0,1,23.165,10.006Z",
    transform: "translate(26.154 15.186)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M27.165,11.2,22.713,25.424,20.781,10.006A19.209,19.209,0,0,1,27.165,11.2Z",
    transform: "translate(32.629 15.186)",
    fill: "#ccd1d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M24.5,10.016l1.931,15.418-2.34,7.48H20.822l-2.341-7.48,1.931-15.418A3.4,3.4,0,0,1,20.822,10H24.1A3.392,3.392,0,0,1,24.5,10.016Z",
    transform: "translate(28.906 15.176)",
    fill: "#ffeaa7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M17.321,10.7v.933a4.91,4.91,0,0,1-9.821,0v-.949A17.363,17.363,0,0,1,12.41,10a17.364,17.364,0,0,1,4.91.687Z",
    transform: "translate(11.129 15.176)",
    fill: "#f0d0b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M15.446,22.141a9.821,9.821,0,1,0-9.821-9.821A9.82,9.82,0,0,0,15.446,22.141Z",
    transform: "translate(8.094 3.035)",
    fill: "#f0d0b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M36.7,22.141a9.821,9.821,0,1,0-9.821-9.821A9.82,9.82,0,0,0,36.7,22.141Z",
    transform: "translate(42.494 3.035)",
    fill: "#f0d0b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M27.082,24.165A11.457,11.457,0,1,0,15.625,12.707,11.457,11.457,0,0,0,27.082,24.165Z",
    transform: "translate(24.282 1.012)",
    fill: "#f0d0b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M94.158,21.25V67.079H2.5V21.25Z",
    transform: "translate(3.035 33.388)",
    fill: "#d3a06c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M51.989,18.75H99.455V25.3H1.25V18.75H51.989Z",
    transform: "translate(1.012 29.341)",
    fill: "#b27946"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M16.457,23.75H44.282a16.368,16.368,0,0,0,0,32.735H16.457A11.449,11.449,0,0,0,5,45.028V35.207A11.449,11.449,0,0,0,16.457,23.75Z",
    transform: "translate(7.082 37.435)",
    fill: "#b4dd7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M59.282,35.207v9.821A11.449,11.449,0,0,0,47.825,56.485H20A16.368,16.368,0,1,0,20,23.75H47.825A11.449,11.449,0,0,0,59.282,35.207Z",
    transform: "translate(31.364 37.435)",
    fill: "#b4dd7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M16.457,43.332H5V31.875A11.449,11.449,0,0,1,16.457,43.332Z",
    transform: "translate(7.082 50.588)",
    fill: "#a0d468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M5,23.75H16.457A11.449,11.449,0,0,1,5,35.207Z",
    transform: "translate(7.082 37.435)",
    fill: "#a0d468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M42.082,23.75V35.207A11.449,11.449,0,0,1,30.625,23.75Z",
    transform: "translate(48.564 37.435)",
    fill: "#a0d468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M42.082,31.875V43.332H30.625A11.449,11.449,0,0,1,42.082,31.875Z",
    transform: "translate(48.564 50.588)",
    fill: "#a0d468"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M30.118,56.485A16.368,16.368,0,1,0,13.75,40.118,16.367,16.367,0,0,0,30.118,56.485Z",
    transform: "translate(21.247 37.435)",
    fill: "#fcd770"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M25.684,32.172a1.637,1.637,0,0,1,1.637,1.637h3.274a4.916,4.916,0,0,0-4.91-4.91V25.625H22.41V28.9H17.5v4.91a4.916,4.916,0,0,0,4.91,4.91h3.274a1.637,1.637,0,0,1,1.637,1.637v1.637H22.41a1.637,1.637,0,0,1-1.637-1.637H17.5a4.916,4.916,0,0,0,4.91,4.91V48.54h3.274V45.266h4.91v-4.91a4.916,4.916,0,0,0-4.91-4.91H22.41a1.637,1.637,0,0,1-1.637-1.637V32.172Z",
    transform: "translate(27.317 40.47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M86.213,59.134V23.125H4.375V59.134ZM7.649,47.824a9.832,9.832,0,0,1,8.036,8.036H7.649ZM74.9,55.86a9.831,9.831,0,0,1,8.036-8.036V55.86Zm8.036-21.425A9.831,9.831,0,0,1,74.9,26.4h8.036ZM71.595,26.4A13.106,13.106,0,0,0,82.939,37.743v6.774A13.106,13.106,0,0,0,71.595,55.862H55.612a17.962,17.962,0,0,0,0-29.463ZM45.294,55.86A14.731,14.731,0,1,1,60.025,41.129,14.747,14.747,0,0,1,45.294,55.86Zm-18-14.731A17.987,17.987,0,0,0,34.974,55.86H18.991A13.106,13.106,0,0,0,7.647,44.516V37.741A13.106,13.106,0,0,0,18.991,26.4H34.974A17.992,17.992,0,0,0,27.29,41.129ZM15.685,26.4a9.832,9.832,0,0,1-8.036,8.036V26.4Z",
    transform: "translate(6.071 36.423)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M102.1,46.454H98.83V43.181A19.654,19.654,0,0,0,85.788,24.7,11.458,11.458,0,1,0,72.582,24.7a19.454,19.454,0,0,0-6.19,3.6,21.21,21.21,0,0,0-7.47-3.907,13.1,13.1,0,1,0-15.112,0A21.222,21.222,0,0,0,36.337,28.3a19.454,19.454,0,0,0-6.19-3.6A11.457,11.457,0,1,0,16.94,24.7,19.653,19.653,0,0,0,3.9,43.181v3.274H.625v9.821H3.9V102.1H98.83V56.275H102.1Zm-6.547-3.274v3.274h-4.91V36.634H87.373v9.821H74.279V44.817a21.177,21.177,0,0,0-5.521-14.249,16.187,16.187,0,0,1,6.612-3.292l-1.159,11.6,4.977,4.98,4.979-4.979-1.159-11.6A16.385,16.385,0,0,1,95.557,43.181ZM62.822,36.634v9.821H55.227L60.8,28.615a18.008,18.008,0,0,1,10.2,16.2v1.637H66.1V36.634Zm-26.188,0v9.821h-4.91V44.817a18.01,18.01,0,0,1,10.2-16.2L47.5,46.454H39.907V36.634ZM45,27.465a17.813,17.813,0,0,1,2.449-.491L46.7,32.92Zm5.935,18.989L49.058,40.46l1.7-13.647h1.2L53.67,40.46,51.8,46.454Zm5.1-13.534-.743-5.945a17.732,17.732,0,0,1,2.447.491Zm23.162-6.107c.164,0,.322.02.486.025l1.082,10.824L79.189,39.23l-1.568-1.568L78.7,26.838C78.865,26.833,79.025,26.813,79.189,26.813ZM71.005,15.356a8.184,8.184,0,1,1,8.184,8.184A8.193,8.193,0,0,1,71.005,15.356ZM41.544,13.719a9.821,9.821,0,1,1,9.821,9.821A9.83,9.83,0,0,1,41.544,13.719Zm-18,13.094a16.5,16.5,0,0,1,3.241.319,3.255,3.255,0,0,1-6.482.007A16.256,16.256,0,0,1,23.54,26.813ZM15.356,15.356A8.184,8.184,0,1,1,23.54,23.54,8.193,8.193,0,0,1,15.356,15.356ZM7.172,43.181a16.391,16.391,0,0,1,9.953-15.055,6.547,6.547,0,0,0,12.829-.007,16.268,16.268,0,0,1,4.016,2.449A21.177,21.177,0,0,0,28.45,44.817v1.637H15.356V36.634H12.082v9.821H7.172ZM95.557,98.83H7.172V56.275H95.557ZM98.83,53H3.9V49.728H98.83Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestors);
export default __webpack_public_path__ + "static/media/investors.064f3a93c169ad64b5d8e69faaaec1e4.svg";
export { ForwardRef as ReactComponent };